import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalComponent from '../../../core/common/modal/ModalComponent'
import { useActiveInactiveContactsMutation, useDeactivateUserToggleMutation } from '../../../services/EndPointsApis'
import { all_routes } from '../../router/all_routes'

type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    setCurrentToggleState?: any
    refetch?: any
}



const ActiveUserModal = ({ show, handleClose, setCurrentToggleState, data, refetch }: Props) => {
    const route = all_routes;
    const [deactivateContactToggle, { data: deActivedata, isError, error, isSuccess }] = useActiveInactiveContactsMutation();
    const navigate = useNavigate();

    const initialValues =
        [
            {
                id: 0,
                isActive: true
            }
        ]
    const formik = useFormik({
        initialValues,
        onSubmit: (values, { resetForm }) => {

            deactivateContactToggle([
                {
                    id: data?.contactId,
                    isActive: data?.isActive === true ? false : true,
                }
            ])

        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            handleClose();
            if (data.active === true) {
                setCurrentToggleState(false);
            }
            else {
                setCurrentToggleState(true);
            }
            resetForm();
            refetch()
        }
    }, [isSuccess]);
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error]);
    return (
        <ModalComponent
            buttonText=""
            modalTitle={data?.active !== true ? 'Active Contact' : "InActive Contact"}
            onClose={handleClose}
            onSave={formik.handleSubmit}
            isVisible={show}
            cancelButton="NO"
            saveButton='Yes'
        >
            <>
                <p>
                    Are you sure you want to {data?.active !== true ? 'Activate Contact' : "DeActivate Contact"}
                </p>
            </>

        </ModalComponent>
    )
}

export default ActiveUserModal